import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Switch } from 'react-router-dom';
// import { Canvas, useFrame } from '@react-three/fiber';
import axios from "axios";
import NavigationBar from "./components/NavigationBar/NavigationBar";
import Parcours from "./components/parcours/Parcours";
import Apropos from "./components/apropos/Apropos";
import Competences from "./components/competences/Competences";
import Realisations from "./components/realisations/Realisations";
// import {Layout} from "./Layout";
import Jumbotron from "./components/jumbotron/Jumbotron";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import Calendrier from "./components/calendar/Calendrier";
import Horloge from "./components/horloge/Horloge";
import Chat from "./components/chat/Chat";
import AdminModal from "./components/adminModal/AdminModal";
// import Animation from "./components/animation/Animations";
import "bootstrap/dist/css/bootstrap.min.css";
// import "../../styles/index.css";
import './App.css';


function App() {

    const [isOnLine, setIsOnLine] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [serverMsg, setserverMsg] = useState('');
    const [isTherMsgs, setIsTherMsgs] = useState(false);
    const URL_CHAT_RENDER = "https://portfolio-chat-io.onrender.com";
    // const URL_CHAT_HEROKU = "https://radiant-springs-15491.herokuapp.com"'

    // const onCloseApp = async (e) => {
    //     e.preventDefault();
    //     // e.returnValue = true; 
    //     let isOnLine = { isOnLine: false }
    //     // console.log('isAdminInside onCloseApp ==>>', isAdmin);
    //     // console.log(isTherMsgs);
    //     if (isAdmin) {
    //         let dialogText = 'Vous voulez quittez? vous perdez tout vos messages dans le chatche';
    //         e.returnValue = dialogText;
    //         await axios.put("https://radiant-springs-15491.herokuapp.com/admin/6246165c126f74b59f392314", isOnLine)
    //             .then(res => {
    //                 // console.log(res.data);
    //                 // let {isAdmin, isOnLine} = res.data 
    //                 setIsOnLine(res.data.isOnLine)
    //                 // forceUpdate(); 
    //             })
    //             .catch(error => {
    //                 console.log(error)
    //             })
    //         return dialogText;
    //     } else if (isTherMsgs) {
    //         let dialogText = 'Vous voulez quittez? vous perdez tout vos messages dans le chatche';
    //         e.returnValue = dialogText;
    //     }
    // }

    // const onBlurFunction = () => {
    //     // do whatever when focus is lost
    //     console.log('is blur');
    //     // setIsOnLine(false);
    // };
    const checkAdmin = async (passwordInput) => {
        // let password = prompt("mot de pass admin ?");
        // let password = { password: "Portfoliotamilla1875" };
        let password = { password: passwordInput };
        // await axios.post("http://localhost:8000/admin/login", password)
        await axios.post(`${URL_CHAT_RENDER}/admin/login`, password)
            .then(res => {
                // console.log(res.data)
                let { isAdmin, isOnLine } = res.data.admin
                let message = res.data.message
                setIsAdmin(isAdmin)
                setIsOnLine(isOnLine)
                setserverMsg(message)
            })
            .catch((error) => {
                // console.log(response)
                setserverMsg(error.response.data.message)
            }) 
    }
    // console.log(isAdmin);
    // useEffect(() => {
    //     onFocusFunction()
    // }, [isAdmin])

    useEffect(() => {
        // checkAdmin(); 
        const onFocusFunction = async () => {
            // do whatever when focus is gained
            // console.log('is focus');
            // await axios.get("http://localhost:8000/admin/6246165c126f74b59f392314")
            await axios.get(`${URL_CHAT_RENDER}/admin/6246165c126f74b59f392314`)
                .then(res => {
                    // console.log(res.data);
                    // let {isAdmin, isOnLine} = res.data 
                    setIsOnLine(res.data.isOnLine)
                })
                .catch(error => {
                    console.log(error)
                })
            // setIsOnLine(true);
        };
        onFocusFunction()
        window.addEventListener("focus", onFocusFunction);
        // window.addEventListener("blur", onBlurFunction);
        // console.log(isAdmin);
        // console.log(isTherMsgs);
        const onCloseApp = async (e) => {
            e.preventDefault();
            // e.returnValue = true; 
            let isOnLine = { isOnLine: false }
            // console.log('isAdminInside onCloseApp ==>>', isAdmin);
            // console.log(isTherMsgs);
            if (isAdmin) {
                let dialogText = 'Vous voulez quittez? vous perdez tout vos messages dans le chatche';
                e.returnValue = dialogText;
                await axios.put(`${URL_CHAT_RENDER}/admin/6246165c126f74b59f392314`, isOnLine)
                    .then(res => {
                        // console.log(res.data);
                        // let {isAdmin, isOnLine} = res.data 
                        setIsOnLine(res.data.isOnLine)
                        // forceUpdate(); 
                    })
                    .catch(error => {
                        console.log(error)
                    })
                return dialogText;
            } else if (isTherMsgs) {
                let dialogText = 'Vous voulez quittez? vous perdez tout vos messages dans le chatche';
                e.returnValue = dialogText;
            }
        }
        window.addEventListener('beforeunload', onCloseApp)
        // window.onbeforeunload = (()=>onCloseApp)
        return () => {
            // onBlurFunction();
            window.removeEventListener("focus", onFocusFunction);
            window.onbeforeunload = null;
            // window.removeEventListener("blur", onBlurFunction);
        };
    }, [isAdmin, isTherMsgs])

    return (
        <React.Fragment>
            <Jumbotron />
            <AdminModal showModal={true} checkAdmin={checkAdmin} >
                {serverMsg && <p style={{ color: '#ff0000' }}>{serverMsg}</p>}
            </AdminModal>
            <BrowserRouter>
                <NavigationBar />
                <div className="mySwitch row">
                    <div className="col-9 ">
                        <Switch>
                            <Route exact path="/" component={Apropos} />
                            <Route path="/apropos" component={Apropos} />
                            <Route path="/parcours" component={Parcours} />
                            <Route path="/competences" component={Competences} />
                            <Route path="/realisations" component={Realisations} />
                            {/* <Route path="/realisations/jsRealisations" component={JsRealisations} />
                            <Route path="/realisations/mernRealisations" component={MernRealisations} /> */}
                            <Route path="/contact" component={Contact} />
                        </Switch>
                    </div>
                    <div className="divCalendrier col-3 pt-3">
                        <Calendrier />
                        <Horloge />
                    </div>
                </div>
                {/* <Animation/>  */}
                <div className="chat-div">
                    <Chat isAdmin={isAdmin} isOnLine={isOnLine} setIsOnLine={setIsOnLine} isTherMsgs={isTherMsgs} setIsTherMsgs={setIsTherMsgs} />
                </div>
                <Footer />
            </BrowserRouter>

        </React.Fragment>

    );
}

export default App;
